<script lang="ts" setup>
	import {computed, onMounted} from 'vue';
	import {getSelectedWeek, scrollWeekIntoView, setSelectedWeek} from 'dummen-shared';
	import {setSelectedWeekAndScroll} from 'dummen-shared/src/services/availability.storage.service';

	const props = defineProps<{
		weeks: Array<string>
	}>();

	const selectedWeek = computed(() => getSelectedWeek());

	const selected = computed(() => {
		if (selectedWeek.value && props.weeks) {
			return props.weeks.find(week => week === selectedWeek.value) ?? props.weeks[0];
		}

		return props.weeks ? props.weeks[0] : null;
	});

	const getSelectedIndex = () => {
		return selected.value ? props.weeks.findIndex(week => week === selected.value) : null;
	};

	const updateSelectedWeek = (event: Event) => {
		const element = event.target as HTMLInputElement;

		if (!element?.value) {
			return;
		}

		setSelectedWeekAndScroll(element?.value);
	};

	const selectPreviousWeek = () => {
		const selectedIndex = getSelectedIndex();

		// Check if there is a previous week.
		if (!selectedIndex) {
			return;
		}

		setSelectedWeek(props.weeks[selectedIndex - 1]);
	};

	const selectNextWeek = () => {
		const selectedIndex = getSelectedIndex();

		// Check if there is a next week.
		if (selectedIndex === null || selectedIndex === props.weeks.length - 1) {
			return;
		}

		setSelectedWeek(props.weeks[selectedIndex + 1]);
	};

	const formatWeek = (week: string) => `${week.substring(4)}${week.substring(0, 4)}`;

	onMounted(() => {
		if (selected.value) {
			scrollWeekIntoView(selected.value, true);
		}
	});

</script>

<template>
	<div class="catalog-overview-header__week">
		<label for="weekSelect">
			{{ $t('site.products.overview.availability.weekselector.label.text') }}
		</label>

		<button type="button" @click="selectPreviousWeek">
			<svg class="icon-triangle-left" height="10" width="8">
				<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#triangle-left"></use>
			</svg>
		</button>

		<select id="weekSelect"
		        :value="selected"
		        @change="updateSelectedWeek($event)">
			<option v-for="week in weeks" :key="week" :value="week">{{ formatWeek(week) }}</option>
		</select>

		<button type="button" @click="selectNextWeek">
			<svg class="icon-triangle-right" height="10" width="8">
				<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#triangle-right"></use>
			</svg>
		</button>
	</div>
</template>
